import LimitedInventoryModal from './LimitedInventoryModal';

export default LimitedInventoryModal;
